import React from 'react'
import ReactToPrint from 'react-to-print';
import { PERFIL_ADMIN } from '../../security/securityContext';
import { validaPerfis } from '../../security/Autorizacao';

export class ModalImpressaoReciboPassageiro extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      referenciaSelecionada: null
    };
  }

  recuperarNomeArquivo(){
    if(this.props.referencias.get(this.state.referenciaSelecionada)){
      return this.props.referencias.get(this.state.referenciaSelecionada).nomeParaImpressao
    }
  }

  montarParametros() {
    return {
      pedidoId: this.props.pedido.id,
      empresaId: this.props.empresaSelecionada.id,
      descricao: this.props.referencias.get(this.state.referenciaSelecionada).nome
    }
  }

  exibirBotaoImprimir () {
    return (
      <React.Fragment>
        <ReactToPrint
          trigger={() => <button disabled={!this.state.referenciaSelecionada}
                                 className="btn btn-laranja">IMPRIMIR
          </button>}
          content={() => {
            // disparar acao para registrar comissao impressao recibo
            if (!validaPerfis([PERFIL_ADMIN])) this.props.cadastrarComissaoReimpressaoRecibo(this.montarParametros());
            return this.props.referencias.get(this.state.referenciaSelecionada).referencia.current
          }}
          documentTitle={this.recuperarNomeArquivo()}
        />
      </React.Fragment>)
  }

  exibirTiposImpressao () {
    return <div>
      {[...this.props.referencias.keys()].map(ref => <div className='row mt-2'key={ref}>
        <div>
          <input type="radio" onChange={() => {
            this.setState({ referenciaSelecionada: ref })
            this.props.checkReferenciaSelecionada (ref)            
          }}   
          checked={this.state.referenciaSelecionada === ref}/>
          <span className='ml-2'>{this.props.referencias.get(ref).nome}</span><br/>
          {this.props.referencias.get(ref).trecho ? <span className='ml-4'>{this.props.referencias.get(ref).trecho}</span> : ''}
        </div>
        </div>)}
    </div>
  }

  render () {
    if (this.props.referencias) {
      return (
        <div className="modal fade show" id='modalImpressaoReciboPassageiro' role='dialog'
             aria-labelledby='modalImpressaoReciboPassageiro' aria-hidden='true' data-backdrop='static'>
          <div className={'modal-dialog modal-dialog-centered modal-md'}>
            <div className="modal-content">
              <div className="modal-header">
                <h5>Selecione o tipo de impressão que deseja</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                        onClick={() => { this.setState({ referenciaSelecionada: null }); this.props.checkReferenciaSelecionada(null) }}>
                  <i className="material-icons">
                    &#xe5cd;
                  </i>
                </button>
              </div>
              <div className="modal-body">
                {this.exibirTiposImpressao()}
              </div>
              <div className="modal-footer">
                {this.exibirBotaoImprimir()}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return '';
  }
}


export default ModalImpressaoReciboPassageiro
